import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-30",
  "use": "icon-icon-nav-30-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-30\"><path d=\"M701.12 285.12A227.072 227.072 0 0 0 474.176 512a227.072 227.072 0 0 0 226.944 226.88A227.072 227.072 0 0 0 928 512a227.072 227.072 0 0 0-226.88-226.88zM247.296 360.704a151.232 151.232 0 1 0-0.128 302.464 151.232 151.232 0 0 0 0.128-302.464z m0 226.944c-41.6 0-75.648-34.048-75.648-75.648 0-41.6 34.048-75.648 75.648-75.648 41.6 0 75.584 34.048 75.584 75.648 0 41.6-33.984 75.648-75.584 75.648z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-30.svg
// module id = MJlm
// module chunks = 3